import React from 'react'
import { Check, Time } from '../../assets/icons'


const ListItemX1 = props => {

	const {
		link,
		source,
		time,
		title
	} = props

	return (
		<div className="list_item_x1">
			<a
				className="_title"
				target="_blank"
				rel="noopener noreferrer"
				href={link}
			>
				{title}
			</a>
			<div className="_info">
				<time className="_time">
					<Time className="_icon" />
					{time}
				</time>
				<span className="_source">
					<Check className="_icon" />
					{source}
				</span>
			</div>
		</div>
	)

}


export default ListItemX1
